import { createSlice } from '@reduxjs/toolkit'
import { NameDto } from 'api/Common/Types'
import { OutstandingUserTicketsSummaryDto } from 'api/Tickets/Types/OutstandingUserTicketsSummaryDto'
import { TicketStatus } from 'api/Tickets/Types/TicketStatus'
import { TicketType } from 'api/Tickets/Types/TicketType'

const initialState: TicketState = {
  statuses: [],
  types: [],
  outstandingTickets: {},
  myTicketViewTypes: [],
  mlStatuses: [],
}

export interface TicketState {
  statuses: TicketStatus[]
  types: TicketType[]
  outstandingTickets: Record<number, number>
  myTicketViewTypes: TicketType[]
  mlStatuses: NameDto[]
}

export const ticketsSlice = createSlice({
  name: 'tickets',
  initialState,
  reducers: {
    getTicketStatus: (state, action: { payload: TicketStatus[] }) => {
      state.statuses = action.payload
    },
    getTicketType: (state, action: { payload: TicketType[] }) => {
      state.types = action.payload
    },
    getOutstandingTicketsUserSession: (
      state,
      action: { payload: OutstandingUserTicketsSummaryDto[] }
    ) => {
      state.outstandingTickets = action.payload.reduce<Record<number, number>>((acc, tickets) => {
        acc[Number(tickets.viewType.id)] = tickets.number
        return acc
      }, {})
    },

    getMyTicketViewTypes: (state, action: { payload: TicketType[] }) => {
      state.myTicketViewTypes = action.payload
    },

    getMlStatuses: (state, action: { payload: NameDto[] }) => {
      state.mlStatuses = action.payload
    },
  },
})
